import { render } from "./WInputWrapper.vue?vue&type=template&id=7b3a1884&ts=true"
import script from "./WInputWrapper.vue?vue&type=script&lang=ts"
export * from "./WInputWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__